module.exports = __webpack_public_path__ + "gafasLogo.png?4545e8cd6be73acc385caa334c510541";